import { httpCreate } from './http';

const http = httpCreate('/srv/cme');

export const cme = {
	create(activityId, data) {
		return http.post(`/project/${activityId}`, data);
	},
	editor(activityId, id, data) {
		return http.put(`/project/${activityId}/${id}`, data);
	},
	delete(activityId, id) {
		return http.delete(`/project/${activityId}/${id}`);
	},
	getList(activityId, params) {
		return http.get(`/project/${activityId}`, { params });
	},
	getSign(activityId, params) {
		return http.get(`/sign/${activityId}`, { params });
	},
	getMediaList(activityId, params) {
		return http.get(`/project/${activityId}/media-list`, { params });
	},
	importMedia(activityId, id, ids) {
		return http.post(`/project/${activityId}/import-medias/${id}`, ids);
	},
	export(activityId, projectId, params) {
		return http.post(`/project/${activityId}/export/${projectId}`, null, { params });
	},
	getTaskList(activityId, params) {
		return http.get(`/task-list/${activityId}`, { params });
	},
	getProgress(taskId) {
		return http.get(`/task-status/${taskId}`);
	},
	// 删除多个
	deleteList(activityId, list) {
		return http.delete(`/project/${activityId}`, { data: list });
	},
};
